module.exports = __webpack_public_path__ + "img/radiant.b16ee190.png";